import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const UserMyOrder = () => {
	const orders = [
		{
			orderId: "Order ID: 0123546",
			date: "29-Jun-23",
			qty: "05",
			status: "Completed",
		},
		{
			orderId: "Order ID: 0123546",
			date: "30-Jun-23",
			qty: "10",
			status: "Pending",
		},
		{
			orderId: "Order ID: 0123546",
			date: "01-Jul-23",
			qty: "15",
			status: "Shipped",
		},
	];

	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										My Orders
									</h5>
								</div>
								<div className="wrapper-table-main">
									<div className="row">
										<div className="col-lg-12">
											<table className="table  responsive-table">
												<thead>
													<tr>
														<th className="th">Order ID</th>
														<th className="th">Date</th>
														<th className="th">QTY</th>
														<th className="th">Status</th>
													</tr>
												</thead>
												<tbody>
													{orders.map((order, index) => (
														<tr key={index}>
															<td className="td" data-label="Order ID">
																{order.orderId}
															</td>
															<td className="td" data-label="Date">
																{order.date}
															</td>
															<td className="td" data-label="QTY">
																{order.qty}
															</td>
															<td className="td" data-label="Status">
																<Link
																	className="dark-color text-decoration-none"
																	to="/my-order-detail"
																>
																	{order.status}
																</Link>
															</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
									{/* <Link
										class="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none w-100"
										to="/my-order-detail"
									>
										<span class="bg-wrapper w-100">Order Detail</span>
									</Link> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserMyOrder;
